<div class="gamejr-container">
  <div class="header">
    @if (isFilter) {
      <h4>Game Master Notes</h4>
    } @else {
      <h4>{{ noteType?.toUpperCase() }} Notes</h4>
    }
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <img src="assets/icons/icon-close.svg" alt="" />
    </button>
  </div>

  <div class="notes-content">
    @if (!isFilter) {
      <div class="create-btn-wrapper">
        <button type="button" class="btn btn-theme" (click)="openCreateNoteModal()">
          Create {{ noteType?.toUpperCase() }} Note
        </button>
      </div>
    }

    @if (notes && notes.length > 0) {
      <div class="notes-list">
        @for (note of notes; track note; let i = $index) {
          <div class="note-item">
            <div class="note-content">
              @if (!isFilter) {
                <div class="note-header">
                  <span class="note-type-badge" [class.private]="note.is_private" [class.public]="!note.is_private">
                    {{ note.is_private ? 'Private' : 'Public' }}
                  </span>
                </div>
              }
              <span class="note-text">{{ note.text }}</span>
            </div>
            @if (!isFilter) {
              <button type="button" class="delete-btn" (click)="deleteNote(note, i)" title="Delete note">
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M6.5 0.75C6.08579 0.75 5.75 1.08579 5.75 1.5V2.25H2C1.58579 2.25 1.25 2.58579 1.25 3C1.25 3.41421 1.58579 3.75 2 3.75H3.25V15C3.25 16.2426 4.25736 17.25 5.5 17.25H13.5C14.7426 17.25 15.75 16.2426 15.75 15V3.75H17C17.4142 3.75 17.75 3.41421 17.75 3C17.75 2.58579 17.4142 2.25 17 2.25H13.25V1.5C13.25 1.08579 12.9142 0.75 12.5 0.75H6.5ZM7.25 2.25V1.5H11.75V2.25H7.25ZM4.75 3.75V15C4.75 15.4142 5.08579 15.75 5.5 15.75H13.5C13.9142 15.75 14.25 15.4142 14.25 15V3.75H4.75ZM7.5 6C7.91421 6 8.25 6.33579 8.25 6.75V12.75C8.25 13.1642 7.91421 13.5 7.5 13.5C7.08579 13.5 6.75 13.1642 6.75 12.75V6.75C6.75 6.33579 7.08579 6 7.5 6ZM11.5 6C11.9142 6 12.25 6.33579 12.25 6.75V12.75C12.25 13.1642 11.9142 13.5 11.5 13.5C11.0858 13.5 10.75 13.1642 10.75 12.75V6.75C10.75 6.33579 11.0858 6 11.5 6Z"
                    fill="currentColor" />
                </svg>
              </button>
            }
          </div>
        }
      </div>
    } @else {
      <div class="no-notes-message">
        @if (!isFilter) {
          <p>No {{ noteType }} notes found. Click &ldquo;Create Note&rdquo; to add one.</p>
        } @else {
          <p>No notes found.</p>
        }
      </div>
    }
  </div>
</div>
